<template>
  <div class="wzb-mid">
    <!-- 支部负责人 -->
    <div class="mid-title">支部委员</div>
    <div class="manager-wrap">
      <div class="manager-person" v-for="item in leader" :key="item.key">
        <img
          class="manager-person_avatar"
          :src="item.headPicUrl || require('../../../assets/images/default.png')"
        />
        <span class="manager-person_name">{{item.realName}}</span>
        <span class="manager-person_job">{{item.proTitle}}</span>
      </div>
    </div>

    <!-- 支部活动 -->
    <div class="wzb-active">
      <section class="active-name">支部活动</section>
      <!-- 活动数 -->
      <section class="active-item">
        <div class="active-item_num">{{huodongNumber}}个</div>
        <div class="active-item_title">活动数</div>
      </section>
      <!-- 签到数 -->
      <section class="active-item">
        <div class="active-item_num">{{qiandaoNumber}}人</div>
        <div class="active-item_title">签到数</div>
      </section>
    </div>

    <!-- 活动风采 -->
    <div class="mid-title">活动风采</div>
    <div class="scroll-wrap">
      <x-scroll
        v-if="index == nowIndex && activityPicList.length > 0"
        :contentArr="activityPicList"
        :height="picHeight"
        :lineNum="4"
        :width="width*0.098"
        :time="4000"
        :chixuTime="4"
      >
        <div
          slot="scroll"
          slot-scope="props"
          :style="{marginRight:width*0.015+'px',width:width*0.083+'px'}"
        >
          <img :src="props.todo" :style="{width: width*0.083+'px',height:picHeight+'px'}" />
        </div>
      </x-scroll>
    </div>
  </div>
</template>

<script>
import xScroll from "../../../components/xScroll";
export default {
  components: {
    xScroll
  },
  data() {
    return {};
  },
  props: {
    index: Number,
    nowIndex: Number,
    height: Number,
    width: Number,
    leader: {
      type: Array,
      default: () => []
    },
    huodongNumber: {
      type: Number,
      default: 0
    },
    qiandaoNumber: {
      type: Number,
      default: 0
    },
    activityPicList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    picHeight() {
      return this.height * 0.185;
    }
  }
};
</script>

<style lang="less" scoped>
.wzb-mid {
  height: 100%;
  position: relative;
}
.mid-title {
  text-align: center;
  font-size: 0.28rem;
  font-weight: 600;
  color: #4c4c4c;
}
.manager-wrap {
  .flex(flex-start, space-between, @flexWrap:wrap);
  margin-top: 0.26rem;
}
.manager-person {
  flex: 1;
  .flex(center, @flexDirection:column);
}
.manager-person_avatar {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
}
.manager-person_name {
  font-size: 0.25rem;
  color: #444;
  font-weight: 600;
}
.manager-person_job {
  font-size: 0.18rem;
  color: #666;
}

.wzb-active {
  .flex(center, space-around);
  color: #ff4500;
  margin: 0.3rem 0;
}
.active-name {
  font-size: 0.24rem;
}
.active-item {
  text-align: center;
}
.active-item_num {
  font-size: 0.3rem;
  font-weight: bold;
}
.active-item_title {
  font-size: 0.22rem;
}
.scroll-wrap {
  .flex(center, center);
  margin-top: 0.3rem;
}
</style>
